import { Subscription, Reducer } from 'umi';

import { NoticeIconData } from '@/components/NoticeIcon';


export interface NoticeItem extends NoticeIconData {
  id: string;
  type: string;
  status: string;
}

export interface GlobalModelState {
  breadcrumb: [];
  collapsed?: any;
  notices?: any
}

export interface GlobalModelType {
  namespace: 'global';
  state: GlobalModelState;

  reducers: {
    changeBreadcrumb: Reducer<GlobalModelState>;
  };
  subscriptions: { setup: Subscription };
}

const GlobalModel: GlobalModelType = {
  namespace: 'global',

  state: {
    breadcrumb: [] // 面包屑
  },
  reducers: {
    changeBreadcrumb(state, { payload }): GlobalModelState {
      return {
        ...state,
        breadcrumb: payload,
      };
    },
  },

  subscriptions: {
    setup({ history }): void {
      // Subscribe history(url) change, trigger `load` action if pathname is `/`
      history.listen(({ pathname, search }): void => {
        if (typeof window.ga !== 'undefined') {
          window.ga('send', 'pageview', pathname + search);
        }
      });
    },
  },
};

export default GlobalModel;
